export const blockIconsTransportationFlightLandNew = (
	<span className='material-symbols-outlined'>flight_land</span>
);
